var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16.5H13.3333C14.0667 16.5 14.6667 15.9 14.6667 15.1667C14.6667 14.4333 14.0667 13.8333 13.3333 13.8333H10.6667C9.93333 13.8333 9.33333 14.4333 9.33333 15.1667C9.33333 15.9 9.93333 16.5 10.6667 16.5ZM0 1.83333C0 2.56667 0.6 3.16667 1.33333 3.16667H22.6667C23.4 3.16667 24 2.56667 24 1.83333C24 1.1 23.4 0.5 22.6667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333ZM5.33333 9.83333H18.6667C19.4 9.83333 20 9.23333 20 8.5C20 7.76667 19.4 7.16667 18.6667 7.16667H5.33333C4.6 7.16667 4 7.76667 4 8.5C4 9.23333 4.6 9.83333 5.33333 9.83333Z",
    fill: "#91278F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.58a8c85ed01e231a779575504a983bba.svg";
export { ForwardRef as ReactComponent };